
import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteUnit = (
    token: string,
    backend: string,
    id: string,
) => {
    return fetch(
        `${getApiUrl(backend)}units/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteUnit